const SEARCH_VIN = 'vin';
const SEARCH_SERIAL = 'serial_number';

export const searchIdentifier = {
    SEARCH_VIN,
    SEARCH_SERIAL,
};
